import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}reports/`;

export default {
  payslips(params = {}) {
    return axios.get(`${API_URL}payslips`, {
      params,
      headers: buildHeaders(),
    });
  },

  myPayslips(params = {}) {
    return axios.get(`${API_URL}my-payslips`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportPayslipsCSV(params = {}) {
    return axios.get(`${API_URL}payslips/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
  exportPayslipsPDF(params = {}) {
    return axios.get(`${API_URL}payslips/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  downloadHistoricalPayslip(params = {}) {
    return axios.get(`${API_URL}historical-payslips/download`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  downloadMyHistoricalPayslip(params = {}) {
    return axios.get(`${API_URL}my-historical-payslips/download`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  p9List(params = {}) {
    return axios.get(`${API_URL}p9`, { params, headers: buildHeaders() });
  },

  legacyP9List(params = {}) {
    return axios.get(`${API_URL}legacy-p9`, {
      params,
      headers: buildHeaders(),
    });
  },

  myP9Years() {
    return axios.get(`${API_URL}my-p9/years`, {
      headers: buildHeaders(),
    });
  },

  myP9Download(year) {
    return axios.get(`${API_URL}my-p9/download`, {
      params: { year },
      responseType: "blob",
      headers: buildHeaders(),
    });
  },

  // Download one employee PDF
  p9Download(employeeId, year) {
    return axios.get(`${API_URL}p9/${employeeId}/download`, {
      params: { year },
      responseType: "blob",
      headers: buildHeaders(),
    });
  },

  legacyP9Download(employeeId, year) {
    return axios.get(`${API_URL}legacy-p9/${employeeId}/download`, {
      params: { year },
      responseType: "blob",
      headers: buildHeaders(),
    });
  },

  legacyP9Email(employeeId, year) {
    return axios.post(
      `${API_URL}legacy-p9/${employeeId}/email?year=${year}`,
      {},
      {
        headers: buildHeaders(),
      },
    );
  },

  p9Email(employeeId, year) {
    return axios.post(
      `${API_URL}p9/${employeeId}/email?year=${year}`,
      {},
      {
        headers: buildHeaders(),
      },
    );
  },

  p9BulkEmail({ year, employee_ids = null } = {}) {
    const payload = { year };
    if (Array.isArray(employee_ids) && employee_ids.length) {
      payload.employee_ids = employee_ids;
    }
    return axios.post(`${API_URL}p9/bulk-email`, payload, {
      headers: buildHeaders(),
    });
  },

  p9ExportZip(year) {
    return axios.get(`${API_URL}p9/export-zip`, {
      params: { year },
      responseType: "blob",
      headers: buildHeaders(),
    });
  },

  // src/services/reports.service.js
  p9ExportCsv(year) {
    return axios.get(`${API_URL}p9/export-csv`, {
      params: { year },
      responseType: "blob",
      headers: buildHeaders(),
    });
  },

  attendance(params = {}) {
    return axios.get(`${API_URL}attendance`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportAttendanceCSV(params = {}) {
    return axios.get(`${API_URL}attendance/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportAttendancePDF(params = {}) {
    return axios.get(`${API_URL}attendance/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  bankTransfer(params = {}) {
    return axios.get(`${API_URL}bank-transfer`, {
      params,
      headers: buildHeaders(),
    });
  },

  cashPayroll(params = {}) {
    return axios.get(`${API_URL}cash-payroll`, {
      params,
      headers: buildHeaders(),
    });
  },

  cashPayrollAudit(params = {}) {
    return axios.get(`${API_URL}cash-payroll/audit`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportBankTransferCSV(params = {}) {
    return axios.get(`${API_URL}bank-transfer/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportBankTransferXlsx(params = {}) {
    return axios.get(`${API_URL}bank-transfer/export`, {
      params: { ...params, format: "xlsx" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportBankTransferPDF(params = {}) {
    return axios.get(`${API_URL}bank-transfer/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCashPayrollCSV(params = {}) {
    return axios.get(`${API_URL}cash-payroll/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCashPayrollPDF(params = {}) {
    return axios.get(`${API_URL}cash-payroll/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCashPayrollAcknowledgmentPDF(params = {}) {
    return axios.get(`${API_URL}cash-payroll/acknowledgment`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCashPayrollAuditCSV(params = {}) {
    return axios.get(`${API_URL}cash-payroll/audit/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCashPayrollAuditPDF(params = {}) {
    return axios.get(`${API_URL}cash-payroll/audit/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  markCashPayrollPaid(id, payload = {}) {
    return axios.post(`${API_URL}cash-payroll/${id}/mark-paid`, payload, {
      headers: buildHeaders(),
    });
  },

  bulkMarkCashPayrollPaid(payload = {}) {
    return axios.post(`${API_URL}cash-payroll/bulk-mark-paid`, payload, {
      headers: buildHeaders(),
    });
  },

  markCashPayrollPending(id) {
    return axios.post(`${API_URL}cash-payroll/${id}/mark-pending`, {}, {
      headers: buildHeaders(),
    });
  },

  checkPayroll(params = {}) {
    return axios.get(`${API_URL}check-payroll`, {
      params,
      headers: buildHeaders(),
    });
  },

  checkPayrollAudit(params = {}) {
    return axios.get(`${API_URL}check-payroll/audit`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportCheckPayrollCSV(params = {}) {
    return axios.get(`${API_URL}check-payroll/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCheckPayrollPDF(params = {}) {
    return axios.get(`${API_URL}check-payroll/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCheckPayrollAuditCSV(params = {}) {
    return axios.get(`${API_URL}check-payroll/audit/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportCheckPayrollAuditPDF(params = {}) {
    return axios.get(`${API_URL}check-payroll/audit/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  issueCheckPayroll(id, payload = {}) {
    return axios.post(`${API_URL}check-payroll/${id}/issue`, payload, {
      headers: buildHeaders(),
    });
  },

  markCheckPayrollPending(id) {
    return axios.post(`${API_URL}check-payroll/${id}/mark-pending`, {}, {
      headers: buildHeaders(),
    });
  },

  musterRoll(params = {}) {
    return axios.get(`${API_URL}muster-roll`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportMusterRollCSV(params = {}) {
    return axios.get(`${API_URL}muster-roll/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportMusterRollExcel(params = {}) {
    return axios.get(`${API_URL}muster-roll/export`, {
      params: { ...params, format: "xlsx" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportMusterRollPDF(params = {}) {
    return axios.get(`${API_URL}muster-roll/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  statutoryDeductions(params = {}) {
    return axios.get(`${API_URL}statutory-deductions`, {
      params,
      headers: buildHeaders(),
    });
  },

  p10(params = {}) {
    return axios.get(`${API_URL}p10`, {
      params,
      headers: buildHeaders(),
    });
  },

  monthlyCompliance(params = {}) {
    return axios.get(`${API_URL}monthly-compliance`, {
      params,
      headers: buildHeaders(),
    });
  },

  importedPayrollHistory(params = {}) {
    return axios.get(`${API_URL}imported-payroll-history`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportMonthlyCompliance(params = {}) {
    return axios.get(`${API_URL}monthly-compliance/export`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportStatutoryDeductionsCSV(params = {}) {
    return axios.get(`${API_URL}statutory-deductions/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportP10CSV(params = {}) {
    return axios.get(`${API_URL}p10/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportP10PDF(params = {}) {
    return axios.get(`${API_URL}p10/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportStatutoryDeductionsPDF(params = {}) {
    return axios.get(`${API_URL}statutory-deductions/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  payrollComparison(params = {}) {
    return axios.get(`${API_URL}payroll-comparison`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportPayrollComparisonCSV(params = {}) {
    return axios.get(`${API_URL}payroll-comparison/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportPayrollComparisonPDF(params = {}) {
    return axios.get(`${API_URL}payroll-comparison/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  payrollControlTotals(params = {}) {
    return axios.get(`${API_URL}payroll-control-totals`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportPayrollControlTotalsCSV(params = {}) {
    return axios.get(`${API_URL}payroll-control-totals/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportPayrollControlTotalsPDF(params = {}) {
    return axios.get(`${API_URL}payroll-control-totals/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  // Loans & Savings report
  loansSavings(params = {}) {
    return axios.get(`${API_URL}loans-savings`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportLoansSavingsCSV(params = {}) {
    return axios.get(`${API_URL}loans-savings/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportLoansSavingsPDF(params = {}) {
    return axios.get(`${API_URL}loans-savings/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  auditTrail(params = {}) {
    return axios.get(`${API_URL}audit-trail`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportAuditTrailCSV(params = {}) {
    return axios.get(`${API_URL}audit-trail/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  exportAuditTrailPDF(params = {}) {
    return axios.get(`${API_URL}audit-trail/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  // =============================
  // Savings & Loans Extra Reports
  // =============================

  // Member Savings
  memberSavings(params = {}) {
    return axios.get(`${API_URL}member-savings`, {
      params,
      headers: buildHeaders(),
    });
  },
  exportMemberSavingsCSV(params = {}) {
    return axios.get(`${API_URL}member-savings/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
  exportMemberSavingsPDF(params = {}) {
    return axios.get(`${API_URL}member-savings/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  // Loan Disbursements
  loanDisbursements(params = {}) {
    return axios.get(`${API_URL}loan-disbursements`, {
      params,
      headers: buildHeaders(),
    });
  },
  exportLoanDisbursementsCSV(params = {}) {
    return axios.get(`${API_URL}loan-disbursements/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
  exportLoanDisbursementsPDF(params = {}) {
    return axios.get(`${API_URL}loan-disbursements/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  // Loan Repayments
  loanRepayments(params = {}) {
    return axios.get(`${API_URL}loan-repayments`, {
      params,
      headers: buildHeaders(),
    });
  },
  exportLoanRepaymentsCSV(params = {}) {
    return axios.get(`${API_URL}loan-repayments/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
  exportLoanRepaymentsPDF(params = {}) {
    return axios.get(`${API_URL}loan-repayments/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  // Monthly Collections
  monthlyCollections(params = {}) {
    return axios.get(`${API_URL}monthly-collections`, {
      params,
      headers: buildHeaders(),
    });
  },
  exportMonthlyCollectionsCSV(params = {}) {
    return axios.get(`${API_URL}monthly-collections/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
  exportMonthlyCollectionsPDF(params = {}) {
    return axios.get(`${API_URL}monthly-collections/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  // Interest Earned
  interestEarned(params = {}) {
    return axios.get(`${API_URL}interest-earned`, {
      params,
      headers: buildHeaders(),
    });
  },
  exportInterestEarnedCSV(params = {}) {
    return axios.get(`${API_URL}interest-earned/export`, {
      params: { ...params, format: "csv" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
  exportInterestEarnedPDF(params = {}) {
    return axios.get(`${API_URL}interest-earned/export`, {
      params: { ...params, format: "pdf" },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
};
